export type {NavBarProps} from './NavBar.type';
import NavBarFooter from './NavBarFooter';
export default NavBarFooter;